import _ from "lodash";
import i18n from "../../../../shared/i18n";
import {store} from "@/plugins/vuex";
import ClsSearchModel from "@/modules/setup/cls/ClsSearchModel.model";
import ClsService from "@/modules/setup/cls/ClsService";
import {CLS_TABLE_NAME, SOURCE_CLS_TABLE} from "@/modules/constants";

let getDefaultTableData = (differentFields = []) => {
  return {
    loading: false,
    rows: [],
    pagination: {
      limit: 50,
      page: 1,
      total: 0,
    },
    ordering: '-created_at',
    search: '',
    searchModel: new ClsSearchModel(),
    extraFilters: {},
    expand: '',
    toggleColumns: {
      fields: [...getDefaultFields(), ...differentFields],
      requiredFields: ['title'],
      defaultFields: ['title', 'created_at'],
    }
  }
};


let getDefaultFields = () => {
  return [
    {key: 'title', label: i18n.t('Title'), sortable: true, tdClass: 'title-col', isVisible: true, expand: ''},
    {key: 'comment', label: i18n.t('Comment'), sortable: true, tdClass: 'comment-col', isVisible: false, expand: ''},
    {
      key: 'created_at',
      label: i18n.t('Created at / Created by'),
      sortable: true,
      tdClass: 'created-data-col',
      isVisible: true,
      expand: 'created_by'
    },
    {
      key: 'updated_at',
      label: i18n.t('Updated at / Updated by'),
      sortable: true,
      tdClass: 'updated-data-col',
      isVisible: false,
      expand: 'updated_by'
    },
    {
      key: 'levels',
      label: i18n.t('Levels'),
      sortable: false,
      tdClass: 'levels-col',
      isVisible: false,
      expand: ''
    },
  ]
}

export default {
  namespaced: true,
  state: {
    tableSource: null,
    tableData: {
      setup: getDefaultTableData(),
    },
    modal: {
      show: false,
      object: null,
      source: null,
      itemsRenderLoading: false
    },
  },
  actions: {
    resetTableDataPaginationPage({state}) {
      state.tableData[state.tableSource].pagination.page = 1;
    },
    updateSearchModel({commit, state}, searchModel) {
      commit('updateSearchModel', new ClsSearchModel({
        ...state.tableData[state.tableSource].searchModel,
        ...searchModel
      }));
    },
    async getTableData({commit, dispatch}, payload) {
      let params = await dispatch('getTableParams', payload);

      commit('updateTableLoading', true);
      const response = await ClsService.getCustomLotSequences(params);
      commit('updateTableLoading', false);

      if (response.success) {
        commit('updateTableData', {
          rows: response.body.results,
          pagination: {limit: params.limit, page: params.page, total: response.body.count},
          ordering: params.ordering,
          search: params.search
        });
      }

      return response;
    },
    async resetTable({state, dispatch}) {
      const extraFilters = state.tableData[state.tableSource].extraFilters;
      const expand = state.tableData[state.tableSource].expand;
      const tmpToggleColumns = _.cloneDeep(state.tableData[state.tableSource].toggleColumns);
      let defaultTableData = getDefaultTableData();
      defaultTableData.pagination.limit = state.tableData[state.tableSource].pagination.limit;
      state.tableData[state.tableSource] = defaultTableData;
      state.tableData[state.tableSource].toggleColumns = tmpToggleColumns;
      state.tableData[state.tableSource].extraFilters = extraFilters;
      state.tableData[state.tableSource].expand = expand;
      dispatch('getTableData');
    },
    async getTableParams({state}, payload = null) {
      let data;
      let tableData = state.tableData[state.tableSource];
      const ordering = await store.dispatch('global/getTableDataOrdering', {
        tableData: tableData,
        tableName: `${CLS_TABLE_NAME}.${state.tableSource}`
      });

      if (payload) {
        data = {
          ...payload.pagination,
          search: payload.search,
          ordering: payload.ordering,
        };
      } else {
        data = {
          ...tableData.pagination,
          search: tableData.search,
          ordering: ordering,
        }
      }

      if (tableData.searchModel) {
        const searchModelData = tableData.searchModel.toJSON();
        data = {
          ...data,
          ...searchModelData
        }
      }

      const defaultExpand = tableData.expand
      const expand = tableData.toggleColumns.fields
        .filter(c => tableData.toggleColumns.defaultFields.includes(c.key) && c.expand && !defaultExpand.includes(c.expand))
        .map(c => c.expand)
        .join(',')

      data.expand = `${expand},${defaultExpand}`;

      if (tableData.extraFilters) {
        data = {...data, ...tableData.extraFilters};
        data.export_params = tableData.extraFilters;
      }

      return data;
    },
    showModal({commit}, {object = null, source} = {}) {
      commit('showModal', {object: _.cloneDeep(object), source});
    },
    hideModal({commit}) {
      commit('hideModal');
    },
    async createCustomLotSequence({dispatch, state}, item) {
      let response = await ClsService.createCustomLotSequence(item);

      if (response.success) {
        if (state.modal.source === SOURCE_CLS_TABLE) {
          dispatch('getTableData');
        }
      }

      return response;
    },
    async updateCustomLotSequence({commit, state}, item) {
      let response = await ClsService.updateCustomLotSequence(item.uuid, item);
      if (response.success && state.modal.source === SOURCE_CLS_TABLE) {
        commit('updateCustomLotSequence', response.body);
      }
      return response;
    },
    async removeCustomLotSequence({dispatch}, item) {
      let response = await ClsService.removeCustomLotSequence(item.uuid);
      if (response.success) {
        dispatch('getTableData');
      }
      return response;
    },
    async updateTableSource({state}, {extraFilters, source, clearTableData = false, expand = null}) {
      state.tableSource = source;
      if (clearTableData) {
        state.tableData[source] = getDefaultTableData();
      }
      state.tableData[source].extraFilters = extraFilters;
      if (expand) {
        state.tableData[source].expand = expand;
      }
    },
    async getModalObject({commit, state}, {uuid, source}) {
      state.modal.itemsRenderLoading = true
      let response = await ClsService.getCustomLotSequence(uuid, '');

      if (response.success) {
        commit('updateModalObject', {object: _.cloneDeep(response.body), source})
      }
      state.modal.itemsRenderLoading = false
    },
    async updateToggleColumns({commit, dispatch}, payload) {
      if (payload.isSaveAction) {
        commit('updateTableLoading', true);
        await commit('updateToggleColumns', payload.selectedColumns);
        await dispatch('getTableData');
        commit('updateTableLoading', false);
      } else {
        await commit('updateToggleColumns', payload.selectedColumns);
      }
    },
    updateItemsRenderLoading({state}, val) {
      state.modal.itemsRenderLoading = val
    }
  },
  mutations: {
    showModal: (state, {object, source}) => {
      state.modal.show = true;
      state.modal.object = object;
      state.modal.source = source;
    },
    hideModal: state => {
      state.modal.show = false
      state.modal.object = null;
      state.modal.source = null;
    },
    updateCustomLotSequence: (state, item) => {
      const index = state.tableData[state.tableSource].rows.findIndex(c => c.uuid === item.uuid);
      state.tableData[state.tableSource].rows[index] = {...state.tableData[state.tableSource].rows[index], ...item};
      state.tableData[state.tableSource].rows = [...state.tableData[state.tableSource].rows];
    },
    updateTableData: (state, payload) => state.tableData[state.tableSource] = {...state.tableData[state.tableSource], ...payload},
    updateTableLoading: (state, payload) => state.tableData[state.tableSource].loading = payload,
    updateSearchModel: (state, searchModel) => state.tableData[state.tableSource].searchModel = searchModel,
    updateModalObject: (state, {object, source}) => {
      state.modal.object = object;
      state.modal.source = source;
    },
    updateToggleColumns: (state, selectedColumns) => {
      state.tableData[state.tableSource].toggleColumns.defaultFields = [...selectedColumns];
      let selectedFields = [];
      let notSelectedFields = [];
      selectedColumns.forEach(s => {
        selectedFields.push({
          ...state.tableData[state.tableSource].toggleColumns.fields.find(f => f.key === s),
          isVisible: true
        });
      });
      state.tableData[state.tableSource].toggleColumns.fields.forEach(f => {
        if (!selectedColumns.includes(f.key)) {
          notSelectedFields.push({...f, isVisible: false});
        }
      });
      state.tableData[state.tableSource].toggleColumns.fields = [...selectedFields, ...notSelectedFields];
    },
  },

  modules: {
  }
}
